"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Chip_1 = __importDefault(require("@mui/material/Chip"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)(Chip_1.default) `
  height: 28px;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  font-size: 14px;
  background-color: white;
  .MuiChip-avatar {
    width: 20px;
    height: 20px;
  }
  &:active {
    box-shadow: none;
  }
  &:hover {
    background-color: white;
  }
`;
